<template>
  <div
    class="tw-px-6 tw-flex tw-py-3 tw-group tw-gap-1 last:tw-pb-0"
    :class="[
      isMine ? 'tw-flex-row-reverse' : 'tw-flex-row'
    ]"
  >
    <i-user-avatar
      v-if="hasSender"
      :fullname="message.user_from_fullname"
      :avatar="message.user_from_avatar_url && message.user_from_avatar_url['64'] && `${$baseHost}/${message.user_from_avatar_url['64']}`"
      size="mini"
      class="tw-flex-shrink-0"
      :class="[
        isMessageFromForeigner ? 'tw-cursor-pointer' : '',
      ]"
      @click="isMessageFromForeigner && navigateToForeignerPage()"
    />
    <div
      class="tw-px-4 tw-py-3 tw-rounded-xl tw-relative tw-overflow-hidden tw-text-dark"
      :class="[
        isMine
          ? 'tw-bg-light dark:tw-bg-dm-light tw-border-none tw-rounded-tr-none'
          : 'tw-border dark:tw-bg-dm-gray-secondary tw-border-gray dark:tw-border-dm-gray  tw-bg-white tw-rounded-tl-none',
      ]"
    >
      <span
        v-if="permit"
        class="tw-w-1 tw-h-full tw-absolute tw-top-0 tw-left-0"
        :class="`tw-bg-${permit.color}`"
      />
      <div class="tw-flex tw-justify-between">
        <strong
          v-if="hasSender"
          :class="[
            isMessageFromForeigner ? 'tw-cursor-pointer hover:tw-underline' : '',
          ]"
          @click="isMessageFromForeigner && navigateToForeignerPage()"
        >
          {{ message.user_from_fullname }}
        </strong>
        <ForeignersMessagingMessageOptions
          v-if="$isInRole(['ADMIN', 'CONSULTANT'])"
          :message="message"
        />
      </div>
      <div
        v-if="permit"
        class="tw-text-xs tw-mb-0.5 tw-text-gray-dark dark:tw-text-bg-dm-gray"
      >
        {{ permit.permit_type_name }}
      </div>
      <p
        class="tw-mb-0"
        v-html="messageBody"
      />
      <time
        :datetime="message.date_created"
        :title="message.date_created"
        class="tw-text-xs tw-text-gray-dark dark:tw-text-dm-gray-dark"
      >
        {{ dateLabel }}
      </time>
    </div>
  </div>
</template>

<script>
import ForeignersMessagingMessageOptions from './ForeignersMessagingMessageOptions.vue';
import { mapState } from 'vuex';

export default {
  components: {
    ForeignersMessagingMessageOptions,
  },

  props: {
    message: {
      type: Object,
      required: true,
    },
    showPermit: {
      type: Boolean,
      default: false,
    },
    loggedInFromForeignerAccount: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState({
      me: (state) => state.v2.shared.profile.me,
      foreigner: (state) => state.v2.foreigner.foreigner.foreigner,
      questionnaires: (state) => state.v2.foreigner.questionnaires.questionnaires,
      searchQuery: (state) => state.v2.admin.messaging.filters.body_search || state.v2.admin.messaging.fulltextSearchValue,
    }),
    hasSender() {
      return !!this.message.user_from_fullname;
    },
    isMine() {
      return this.me.id === this.message.user_from_id;
    },
    permit() {
      if (!this.showPermit) {
        return false;
      }
      return this.$store.state.v2.admin.foreigners.foreigner.permits.find(({ id }) => id === this.message.permit_id);
    },
    messageBody() {
      let body = this.$sanitize(this.message.body).replace(/\n/g, '<br>');

      if (this.searchQuery && this.searchQuery.length > 0) {
        const pattern = new RegExp('(' + this.searchQuery + ')', 'gi');
        body = body.replace(pattern, '<strong>$1</strong>');
      }

      return body;
    },
    dateLabel() {
      const messageDate = this.$dayjs(this.message.date_created, 'DD.MM.YYYY HH:mm:ss');
      return messageDate.isToday() ? messageDate.format('HH:mm') : messageDate.format('DD.MM.YYYY HH:mm');
    },
    isMessageFromForeigner() {
      return this.message.user_from_role !== this.$roles.ADMIN
        && this.message.user_from_role !== this.$roles.CONSULTANT
        && this.message.user_from_role !== this.$roles.AGENCY
        && this.message.user_from_role !== this.$roles.HR;
    },
  },
  methods: {
    navigateToForeignerPage() {
      if (this.loggedInFromForeignerAccount) {
        this.$router.push({
          name: 'dashboardForeigner',
          params: {
            fid: this.message.user_from_id,
          },
        });
      } else {
        this.$router.push({
          name: 'foreignersPermit',
          params: {
            fid: this.message.user_from_id,
          },
        });
      }
    },
  },
};
</script>
